require('./lbErrorModal.scss');

const lbErrorModal = angular.module('app.lbErrorModal', []);

lbErrorModal.component('lbErrorModal', {
  controllerAs: 'vm',
  controller: ['lbModalService', lbErrorModalCtrl],
  template: require('./lbErrorModal.html')
});

function lbErrorModalCtrl(lbModalService) {
  let vm = this;

  const DEFAULT_MSG = 'Error';
  const DEFAULT_ERROR_DESC = 'Whoops, there has been an error. Please try again.';
  const DEFAULT_ERROR_DESC_INFO = 'We are really sorry about that.';
  const DEFAULT_REJECTION= {
    status: '',
    statusText: '',
    data: {}
  };

  const rejection = lbModalService.params().rejection || DEFAULT_REJECTION;

  vm.warnLevel = lbModalService.params().warnLevel || 'warning';
  vm.errorMessage = DEFAULT_MSG;
  vm.errorDesc = DEFAULT_ERROR_DESC;
  vm.instructions = `${ rejection.status } ${ rejection.statusText }`;

  vm.close = lbModalService.resolve;

  if(vm.warnLevel === 'info') {
    vm.errorDesc = DEFAULT_ERROR_DESC_INFO;

    if(rejection.data.Message) {
      vm.errorMessage = rejection.data.Message;
    }
  }

  if(rejection.data.Instructions) {
    vm.instructions = rejection.data.Instructions;
  }
}

export default lbErrorModal;


// WEBPACK FOOTER //
// ./src/components/lbErrorModal/lbErrorModal.js